/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Plan_Price_69Inputs */

const en_plan_price_69 = /** @type {(inputs: Plan_Price_69Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`$69`)
};

const es_plan_price_69 = /** @type {(inputs: Plan_Price_69Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`$69`)
};

const fr_plan_price_69 = /** @type {(inputs: Plan_Price_69Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`$69`)
};

const de_plan_price_69 = /** @type {(inputs: Plan_Price_69Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`69 $`)
};

const ja_plan_price_69 = /** @type {(inputs: Plan_Price_69Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`$69`)
};

const zh_plan_price_69 = /** @type {(inputs: Plan_Price_69Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`$69`)
};

const ar_plan_price_69 = /** @type {(inputs: Plan_Price_69Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`$69`)
};

const id_plan_price_69 = /** @type {(inputs: Plan_Price_69Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`$69`)
};

const it_plan_price_69 = /** @type {(inputs: Plan_Price_69Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`$69`)
};

const ru_plan_price_69 = /** @type {(inputs: Plan_Price_69Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`$69`)
};

const pt_plan_price_69 = /** @type {(inputs: Plan_Price_69Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`$69`)
};

const ko_plan_price_69 = /** @type {(inputs: Plan_Price_69Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`$69`)
};

/**
* | output |
* | --- |
* | "$69" |
*
* @param {Plan_Price_69Inputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const plan_price_69 = /** @type {((inputs?: Plan_Price_69Inputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Plan_Price_69Inputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_plan_price_69(inputs)
	if (locale === "es") return es_plan_price_69(inputs)
	if (locale === "fr") return fr_plan_price_69(inputs)
	if (locale === "de") return de_plan_price_69(inputs)
	if (locale === "ja") return ja_plan_price_69(inputs)
	if (locale === "zh") return zh_plan_price_69(inputs)
	if (locale === "ar") return ar_plan_price_69(inputs)
	if (locale === "id") return id_plan_price_69(inputs)
	if (locale === "it") return it_plan_price_69(inputs)
	if (locale === "ru") return ru_plan_price_69(inputs)
	if (locale === "pt") return pt_plan_price_69(inputs)
	return ko_plan_price_69(inputs)
});